import { render, staticRenderFns } from "./TiwitterActionForm.vue?vue&type=template&id=535badfa&scoped=true"
import script from "./TiwitterActionForm.vue?vue&type=script&lang=js"
export * from "./TiwitterActionForm.vue?vue&type=script&lang=js"
import style0 from "./TiwitterActionForm.vue?vue&type=style&index=0&id=535badfa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535badfa",
  null
  
)

export default component.exports